const CONSTANTS = module.exports = {};

CONSTANTS.EXTERNAL_API_ROLES = {
    RESERVATION_MANAGER: 'reservation_manager',// can check availability, handle reservations
    PARTNER: 'partner',// can get topX deals,
};